<template>
  <div>
    <transition name="event-full-nav-help">
      <div v-if="!isDismissed && isVisible">
        <svg width="0" height="0">
          <clipPath id="overlayPath">
            <path
              class="st0"
              d="M0,0v10c151.9,0,275,123.1,275,275S151.9,560,0,560v10h285V0H0z"
            />
          </clipPath>
        </svg>
        <div class="event-full-nav-help-overlay" @click="dismiss">
          <div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div></div>
        </div>
        <div class="event-full-nav-help-tooltip">
          <i class="fas fa-mouse-alt"></i>
          <div>
            Use <strong>side navigation</strong> to guide you through the page
          </div>
        </div>
        <div
          class="event-full-nav-help-cursor"
          :style="`top: ${cursorPosition.y}px; left: ${cursorPosition.x}px`"
        >
          <svg viewBox="0 0 106 106">
            <path
              fill="none"
              stroke="var(--primary)"
              stroke-dasharray="2, 2"
              d="M106,53c0,29.3-23.7,53-53,53C-17.3,103.2-17.3,2.8,53,0C82.3,0,106,23.7,106,53L106,53z"
            />
            <line stroke="#ffffff" x1="37.5" y1="68.5" x2="68.5" y2="37.5" />
            <line stroke="#ffffff" x1="37.5" y1="37.5" x2="68.5" y2="68.5" />
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      cursorPosition: { x: 0, y: 0 }
    }
  },
  computed: {
    trigger() {
      return document.querySelector('[data-help-trigger]')
    },
    isDismissed() {
      return this.$store.getters.isHelpDismissed
    }
  },
  mounted() {
    this.initCursor()
    window.addEventListener('mousemove', this.moveCursor)
    window.addEventListener('scroll', this.watchScroll)
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.moveCursor)
    window.removeEventListener('scroll', this.watchScroll)
  },
  methods: {
    initCursor() {
      this.cursorPosition = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      }
    },
    moveCursor(e) {
      this.cursorPosition = { x: e.x, y: e.y }
    },
    dismiss() {
      this.$store.dispatch('dismissHelp')
      window.removeEventListener('mousemove', this.moveCursor)
    },
    watchScroll() {
      if (!this.isVisible && this.trigger.getBoundingClientRect().top < 0) {
        this.isVisible = true

        setTimeout(() => {
          this.$store.dispatch('dismissHelp')
        }, 4000)
      }
    }
  }
}
</script>

<style lang="scss">
// .event-full-nav-help-overlay {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   display: flex;

//   > div:first-child {
//     width: 285px;

//     > div {
//       height: calc((100vh - 570px) / 2);
//       background: rgba(#000, 0.36);
//       -webkit-backdrop-filter: blur(4px);
//       backdrop-filter: blur(4px);

//       &:nth-child(2) {
//         height: 570px;
//         clip-path: url(#overlayPath);
//       }
//     }
//   }

//   > div:last-child {
//     flex-grow: 1;
//     background: rgba(#000, 0.36);
//     -webkit-backdrop-filter: blur(4px);
//     backdrop-filter: blur(4px);
//   }
// }

// .event-full-nav-help-cursor {
//   width: 106px;
//   height: 106px;
//   border: solid 1px blue;
//   position: fixed;
//   transform: translate(-50%, -50%);
//   pointer-events: none;
// }

// .event-full-nav-help-leave-active {
//   transition: opacity 0.2s;
// }

// .event-full-nav-help-leave-to {
//   opacity: 0;
// }
</style>
